var _ = Object.defineProperty;
var P = (n, e, t) => e in n ? _(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var h = (n, e, t) => P(n, typeof e != "symbol" ? e + "" : e, t);
import { jsx as v } from "react/jsx-runtime";
import { createContext as w } from "react";
const E = "@gjensidige/core-analytics", k = "17.0.0", m = "not-set", i = "application_module", c = "event_module", l = {
  [i]: m,
  application_name: m,
  business_area: m,
  customer_segment: m,
  event_source: E,
  event_version: k
}, a = ({ options: n, config: e }, t = {}) => {
  if (e.syncModules) {
    const o = n[i] === n[c], s = t[i] && t[c] && t[i] != t[c];
    o && t[i] && !s && (t[c] = t[i]);
  }
  return e.reloadPagePath && (n.page_pathname = void 0), Object.assign(n, u({ ...n, ...t }, e));
};
class L {
  constructor(e, t) {
    h(this, "options", { ...l });
    // We can do this due to P never being more constrained than TrackOptions
    h(this, "config", {
      syncModules: !0,
      reloadPagePath: !1,
      pagePathFormat: p
    });
    this.config = Object.assign(this.config, t), a(this, e);
  }
  setConfig(e = {}) {
    this.config = Object.assign(this.config, e), a(this);
  }
  setOptions(e) {
    a(this, e);
  }
  trackEvent(e, t) {
    T(e, a(this, t), void 0, this.config);
  }
  trackEcommerceEvent(e, t) {
    O(e, a(this, t), void 0, this.config);
  }
  trackView(e) {
    $(a(this, e), this.config);
  }
  trackEcommerceView(e) {
    b(a(this, e), this.config);
  }
}
const T = (n, e, t, o) => r({ ...e, ...n }, { method: "link", done: t, config: o }), O = (n, e, t, o) => r({ ...e, ...n }, { method: "link", done: t, config: o }), $ = (n, e) => r(n, { method: "view", config: e }), b = (n, e) => r(n, { method: "view", config: e }), j = w({
  options: { ...l }
}), M = ({ options: n, ...e }) => /* @__PURE__ */ v(j.Provider, { value: { options: n }, ...e });
let f = 0;
function r(n = {}, {
  method: e,
  done: t,
  config: o = { pagePathFormat: p }
}) {
  var g;
  const s = (g = window.utag) == null ? void 0 : g[e].bind(window.utag);
  if (s)
    return t ? s(u(n, o), t) : s(u(n, o));
  f < 10 ? setTimeout(() => r(n, { method: e, config: o }), 100, f++) : console.error(`window.utag.${e} not found `, n);
}
function u(n, e = { pagePathFormat: p }) {
  const t = { ...l };
  return Object.entries(n).forEach(([o, s]) => {
    const g = o === "eventLabel" || o === "eventStatus", d = o.replace(/[A-Z]/g, "_$&").toLowerCase();
    g && s && (s = `${s}`.toLowerCase().split(" ").join("-")), t[d] = s;
  }), {
    ...t,
    [c]: t[c] || t[i],
    page_pathname: t.page_pathname || e.pagePathFormat(t),
    measure_source: t.event_source,
    measure_version: t.event_version
  };
}
function p(n) {
  return `${window.location.pathname.replace(/\/$/, "")}/${n.application_name}/${n[i]}/${n.scenario_name}/${n.scenario_step}`.replace(/\/(undefined|null|not-set)/g, "").replace("/Din+side/", "/Din-side/");
}
export {
  l as DEFAULT_CONTEXT_TRACKING,
  L as Tracking,
  j as TrackingContext,
  M as TrackingProvider,
  O as trackEcommerceEvent,
  b as trackEcommerceView,
  T as trackEvent,
  $ as trackView
};
//# sourceMappingURL=index.js.map
